import { useContext } from 'react';

// auth provider
import SessionContext from 'contexts/SessionContext';

// ==============================|| SESSION AUTH HOOKS ||============================== //

export default function useSession() {
  const context = useContext(SessionContext);

  if (!context) throw new Error('useSession must be used inside SessionProvider');

  return context;
}

// New hook for route-level authentication check
export function useSessionGuard() {
  try {
    const context = useContext(SessionContext);

    if (!context) {
      throw new Error('useSessionGuard must be used inside SessionProvider');
    }

    // Add null checks and default values
    const isLoggedIn = context?.isLoggedIn ?? false;
    const isInitialized = context?.isInitialized ?? false;

    // Return authentication status and loading state
    const result = {
      isAuthenticated: isLoggedIn,
      isLoading: !isInitialized,
      ...context
    };

    return result;
  } catch (error) {
    // Return safe default values
    return {
      isAuthenticated: false,
      isLoading: true,
      error: error.message
    };
  }
}
